import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Content } from './components/Content/Content';
import { ModalPdf } from './components/ModalPdf/ModalPdf';

import { Wrapper } from './Evaluations.styles';
import { Actions } from './components/Actions/Actions';
import { Header } from './components/Header/Header';
import { CompaignFilledProvider } from './context/CompaignFilled';

export type drawerInfoProps = {
	isOpen: boolean;
	url: string;
};

type EvaluationsProps = {
	isCommunicationsEmpty: boolean;
	onChangeToResults: () => void;
};

export const Evaluations = ({
	isCommunicationsEmpty,
	onChangeToResults,
}: EvaluationsProps): JSX.Element => {
	const [drawerInfo, setDrawerInfo] = useState<drawerInfoProps>({
		isOpen: false,
		url: '',
	});
	const [communicationOpen, setCommunication] = useState(false);

	const { id: campaignId } = useParams() as { id: string };

	return (
		<CompaignFilledProvider>
			<Wrapper>
				<ModalPdf
					isOpen={drawerInfo.isOpen}
					url={drawerInfo.url}
					onClose={() => setDrawerInfo({ isOpen: false, url: '' })}
				/>
				<Header
					isCommunicationsEmpty={isCommunicationsEmpty}
					communicationOpen={communicationOpen}
					onCloseComunication={() => setCommunication(false)}
					campaignId={campaignId}
				/>
				<Content campaignId={campaignId} onChangeDrawerInfo={setDrawerInfo} />
				<Actions
					isCommunicationsEmpty={isCommunicationsEmpty}
					setCommunication={setCommunication}
					onChangeToResults={onChangeToResults}
				/>
			</Wrapper>
		</CompaignFilledProvider>
	);
};
